import React, { ChangeEvent } from 'react';

import ShadowedList from 'components/ShadowedList';
import Typography from 'kingpin/atoms/Typography';
import Inputs from 'components/Inputs';
import FilterPlates from 'components/FilterPlates';
import { LabelDiv } from 'screens/Boards/PerformanceBoardForm';
import DatasetFieldPicker from '../../DatasetFieldPicker';
import EmptyVis from '../../Sections/EmptyVis';
import Grid from '../../Sections/Grid';
import WidgetFooter from '../../WidgetFooter';
import { WidgetWrapper } from '../MetricSlideoutWizard/styles';
import SlideoutDateFilterInput from '../SlideoutDateFilterInput';

const GridSlideoutWizard = ({
  saveWidget,
  title,
  onTitleChanged,
  dateFilter,
  onDateFilterModeChanged,
  setInterval,
  setLookback,
  setDateField,
  fields,
  setFields,
  dataset,
  setDataset,
  isDisabled,
  gridSection,
  close,
}: {
  saveWidget: () => void;
  title: string;
  onTitleChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  dateFilter: PerformanceBoardTypes.SlideOut.SlideOutDateFilter;
  onDateFilterModeChanged: (
    mode: PerformanceBoardTypes.SlideOut.SlideOutDateFilter['mode'],
  ) => void;
  setInterval: React.Dispatch<
    React.SetStateAction<PerformanceBoardTypes.SlideOut.SlideOutDateRange>
  >;
  setLookback: (next: PerformanceBoardTypes.SlideOut.RollingLookback) => void;
  setDateField: React.Dispatch<React.SetStateAction<string | undefined>>;
  fields: string[];
  setFields: React.Dispatch<React.SetStateAction<string[]>>;
  dataset: string | undefined;
  setDataset: React.Dispatch<React.SetStateAction<string | undefined>>;
  isDisabled: boolean;
  gridSection: PerformanceBoardTypes.SlideOut.GridSection | undefined;
  close: () => void;
}) => {
  return (
    <>
      <ShadowedList>
        <WidgetWrapper>
          <div style={{ marginBottom: 24 }}>
            <LabelDiv>
              <Typography.Body type="Label">Widget Title</Typography.Body>
            </LabelDiv>
            <Inputs.TextInput
              value={title}
              placeholder="Enter Title"
              onChange={onTitleChanged}
              maxLength={40}
              autoFocus
              data-testid={'title'}
            />
          </div>
          <DatasetFieldPicker
            fields={fields}
            setFields={setFields}
            dataset={dataset}
            setDataset={setDataset}
          />
          <SlideoutDateFilterInput
            dataset={dataset}
            dateFilter={dateFilter}
            onDateFilterModeChanged={onDateFilterModeChanged}
            setInterval={setInterval}
            setLookback={setLookback}
            setDateField={setDateField}
          />
          {!!dataset && (
            <div style={{ marginBottom: 24 }}>
              <LabelDiv>
                <Typography.Body type="Label">Scope</Typography.Body>
              </LabelDiv>
              <FilterPlates isScope />
            </div>
          )}
          {isDisabled || !gridSection ? (
            <EmptyVis />
          ) : (
            <>
              <LabelDiv>
                <Typography.Body type="Label">Preview</Typography.Body>
              </LabelDiv>
              <Grid section={gridSection} />
            </>
          )}
        </WidgetWrapper>
      </ShadowedList>

      <WidgetFooter
        saveWidget={saveWidget}
        sectionType="Simple Grid"
        isDisabled={isDisabled}
        close={close}
      />
    </>
  );
};

export default GridSlideoutWizard;
